const message = ['Qué bueno verte de nuevo,', 'Bienvenido,', 'Hola,'];

export const randomGreeting = () => {
    const number = Math.floor(Math.random() * message.length);
    return message[number];
};
